import React, { useEffect, useMemo } from "react";
import { inject, observer } from "mobx-react";
import { useParams, withRouter } from "react-router-dom";
import withStyles from "react-jss";
import classNames from "classnames";
import { useQuery } from "@apollo/client";
import Container from "reactstrap/lib/Container";
import useDefaultParams from "Services/useDefaultParams";
import { generateUrl } from "Services/withDefaultParams";
import {
	PROVIDERS_WITH_TARIFFS_PLAN_C_QUERY,
	PROVIDERS_WITH_TARIFFS_QUERY,
	TARIFF_TAGS_QUERY,
} from "Services/queries";
import { useHistory } from "react-router";
import { sendMetriks } from "Services/sendMetriks";
import FILTER_TYPES from "./FILTER_TYPES";
import TariffsFilterContainer from "./TariffsFilterContainer";
import routes from "Configs/routes";
import Row from "reactstrap/lib/Row";
import { newFormList } from "Constants/Tags";
import AddressSearchContainer from "Containers/AddressSearchContainer";
import TopProviderContainer from "Containers/TopProviderContainer";
import TariffsWithTagList from "Containers/TariffsWithTagList";
import { AdverBlockContainer } from "Containers/AdBlocksContainer";
import PaginationContainer from "../Containers/PaginationContainer";
import { Redirect404 } from "ComponentsUI/Redirects";
import Stub from "./Stub";
import ProvidersWithTariffsNoQuery from "ComponentsUI/ProvidersWithTariffsNoQuery";
import { TagButton } from "ComponentsUI/Buttons";
import { StubTariffsTags } from "ComponentsUI/Stub";
import { parse } from "query-string";
import { useFilterParams } from "hooks/useFilterParams";
import { isMainSiteCode } from "Utils/siteConfig";

let v4 = require("uuid/v4");

const styles = (theme) => ({
	buttonSet: {
		justifyContent: "flex-start",
		marginBottom: "50px",
	},
	block: {
		display: "block",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		buttonSet: {
			marginBottom: "20px",
		},
	},
});

const Page = (props) => {
	const handleChoose = (value) => {
		// if (value === "home") {
		//     Metrika.getInstance().google.sendEvent(
		//         EVENT_CATEGORY_CLICK_BUTTON,
		//         EVENT_ACTION_CLICK_FLAT_BUTTON
		//     );
		// } else {
		//     Metrika.getInstance().google.sendEvent(
		//         EVENT_CATEGORY_CLICK_BUTTON,
		//         EVENT_ACTION_CLICK_OFFICE_BUTTON
		//     );
		// }
	};

	const onProviderRates = (provider) => {
		props.history.push({
			pathname: generateUrl(routes.ProviderRates.route, {
				providerName: provider.url_name,
				regionUrl: provider.region.url,
			}),
		});
	};

	const onProviderConnect = (provider) => {
		let {
			ApplicationModel: { tariffsModel },
		} = props;
		tariffsModel.setProvider(provider);
	};

	let {
		ApplicationModel: { windowSizeModel, ratesModel, text, mobileFiltersTouchModel, providerModel },
		classes,
		match,
		location: { search },
	} = props;
	const siteCode = props.ApplicationModel.siteCode;
	let tagCode = match.params.tagCode;
	const routerParams = useParams();
	const defaultParams = useDefaultParams(routerParams);
	const history = useHistory();
	const searchParams = useMemo(() => parse(search), [search]);

	const { resetFiltersParams } = useFilterParams();

	let newForm = false;
	useEffect(() => {
		sendMetriks("LOAD_TAG_PAGE_RATES");
	}, [tagCode]);

	if (newFormList.includes(tagCode)) {
		newForm = true;
	}

	const tariffsTagsQuery = useQuery(TARIFF_TAGS_QUERY, {
		variables: {
			filter: `region.url=${defaultParams.regionUrl}`,
		},
		skip: !defaultParams.regionUrl,
	});

	let tariffTags = tariffsTagsQuery?.data?.tariffsTags?.data;
	let tariffTagsFilterCount = [];
	if (tariffTags) {
		tariffTagsFilterCount = tariffTags.filter((elem) => elem.count);
	}

	let providerLimit = 20;
	let tariffLimit = 30;
	let page = 1;
	if (props.match.params.page) {
		page = props.match.params.page;
	}
	let tariffsFilter = [];
	let tariffsFilterProvider = [];
	if (tagCode && tariffTags?.length) {
		const foundTag = tariffTags.find((x) => x.url === tagCode);
		if (foundTag) {
			tariffsFilter.push(foundTag.filter);
			tariffsFilterProvider.push(foundTag.filter);
		} else {
			return <Redirect404 message404={"Отсутствует тег тарифа в регионе в контейнере"} />;
		}
	}

	if (defaultParams.regionUrl) {
		tariffsFilter.push(`region.url=${defaultParams.regionUrl}`);
		tariffsFilterProvider.push(`region.url=${defaultParams.regionUrl}`);
	}

	if (searchParams.providers) {
		tariffsFilter.push(`provider_id=${searchParams.providers}`);
	}

	const tariffsQuery = useQuery(PROVIDERS_WITH_TARIFFS_QUERY, {
		variables: {
			tariffFilter: tariffsFilter.join("&"),
			providerLimit: providerLimit,
			providerOffset: page > 0 ? providerLimit * (page - 1) : 0,
			tariffsPerProvider: 2,
			providerJoin: true,
			vipProvider: true,
			sort: searchParams.sort ? searchParams.sort : null,
		},
		skip: newForm || !defaultParams.regionUrl || !tariffTags,
	});

	const tariffsQueryProvider = useQuery(PROVIDERS_WITH_TARIFFS_QUERY, {
		variables: {
			tariffFilter: tariffsFilterProvider.join("&"),
			providerLimit: providerLimit,
			providerOffset: page > 0 ? providerLimit * (page - 1) : 0,
			tariffsPerProvider: 2,
			providerJoin: true,
			vipProvider: true,
			sort: searchParams.sort ? searchParams.sort : null,
		},
		skip: newForm || !defaultParams.regionUrl || !tariffTags,
	});

	const tariffNewFormQueryProvider = useQuery(PROVIDERS_WITH_TARIFFS_PLAN_C_QUERY, {
		variables: {
			tariffFilter: tariffsFilterProvider.join("&"),
			providerJoin: true,
			tariffLimit: tariffLimit,
			tariffOffset: page > 0 ? tariffLimit * (page - 1) : 0,
			sort: searchParams.sort ? searchParams.sort : "",
		},
		skip: !newForm || !defaultParams.regionUrl || !tariffTags,
	});

	const tariffNewFormQuery = useQuery(PROVIDERS_WITH_TARIFFS_PLAN_C_QUERY, {
		variables: {
			tariffFilter: tariffsFilter.join("&"),
			providerJoin: true,
			tariffLimit: tariffLimit,
			tariffOffset: page > 0 ? tariffLimit * (page - 1) : 0,
			sort: searchParams.sort ? searchParams.sort : "",
		},
		skip: !newForm || !defaultParams.regionUrl || !tariffTags,
	});

	// if (
	//     tariffsTagsQuery.loading ||
	//     tariffsQuery.loading ||
	//     tariffNewFormQuery.loading ||
	//     tariffsQueryProvider.loading
	// ) {
	//     return <StubTariffsTags tagsList={11} search={true} />;
	// }

	let tariffs;
	let tariffsAll;
	let providerIds;
	let pagination;
	let limit;

	if (newForm) {
		limit = tariffLimit;
		tariffsAll = tariffNewFormQueryProvider?.data?.providersWithTariffsPlanC?.data || [];
		tariffs = tariffNewFormQuery?.data?.providersWithTariffsPlanC?.data || [];
		providerIds = tariffNewFormQueryProvider?.data?.providersWithTariffsPlanC?.providerIds || [];
		pagination = tariffNewFormQuery?.data?.providersWithTariffsPlanC?.pagination;
	} else {
		limit = providerLimit;
		tariffsAll = tariffsQueryProvider?.data?.providersWithTariffs?.data || [];
		tariffs = tariffsQuery?.data?.providersWithTariffs?.data || [];
		providerIds = tariffsQueryProvider?.data?.providersWithTariffs?.providerIds || [];
		pagination = tariffsQuery?.data?.providersWithTariffs?.pagination;
	}

	let providersNoQuery = [];
	for (const id of providerIds) {
		const found = tariffs.find((x) => x?.provider?.id === id);
		if (found) {
			providersNoQuery.push(found.provider);
		}
	}

	let providers = [];
	for (const id of providerIds) {
		const found = tariffsAll.find((x) => x?.provider?.id === id);
		if (found) {
			providers.push({ ...found.provider });
		}
	}

	const operatorRatesMobile = generateUrl(routes.RatesMobile.route, {
		regionUrl: defaultParams.regionUrl,
	});

	for (const provider of providers) {
		provider.linkProviderSelect = generateUrl(routes.ProviderDetails.route, {
			providerName: provider.url_name,
			regionUrl: provider.region.url,
		});
		provider.linkProviderReviews = generateUrl(routes.ProvidersReviewListOld.route, {
			regionUrl: provider.region.url,
			providerName: provider.url_name,
		});
		provider.linkProviderConnect = generateUrl(routes.OrderHome.route, {
			regionUrl: provider.region.url,
		});
	}

	function currentOperators() {
		const id = searchParams.providers.split(",");
		return providers.filter((provider) => id.includes(String(provider.id)));
	}

	const currentOperator = searchParams.providers ? currentOperators() : [];

	const filtersItems = [
		{
			type: FILTER_TYPES.SELECT,
			props: {
				multiselect: true,
				title: text.FILTERS_PROVIDER,
				placeholder: text.EVERYTHING,
				activePlaceHolder: text.EVERYTHING,
				items: providers,
				findItems: currentOperator,
				inputName: "select_providers",
				onItemSelect: (providers) => {
					let id = providers.map((provider) => {
						return provider.id;
					});
					history.push({
						search: providers ? `?providers=${id.join(",")}` : "",
					});
					// setFilterParams(initalFilters, {
					//     providers: provider,
					// });
				},
				onFocus() {
					mobileFiltersTouchModel.setFocus();
				},
				onBlur() {
					mobileFiltersTouchModel.removeFocus();
				},
			},
		},
	];

	return (
		<>
			<AddressSearchContainer callback={(value) => handleChoose(value)} sendGAWhenFulled={true} />
			{isMainSiteCode(siteCode) && <div></div>}
			{!!tariffTagsFilterCount.length && (
				<Row className={classNames(classes.buttonSet, classes.block)}>
					<Container>
						<TagButton ratesButton={true} />
						{tariffTags?.length &&
							tariffTags
								.filter((x) => x.count)
								.map((tag) => (
									<TagButton
										elem={tag}
										key={tag.url}
										active={tagCode === tag.url}
										ratesButton={true}
									/>
								))}
						<TagButton
							anotherUrl={operatorRatesMobile}
							elem={{
								name: text.SIM_CARDS,
							}}
						/>
					</Container>
				</Row>
			)}
			{filtersItems && (
				<TariffsFilterContainer
					filters={filtersItems}
					tagCode={tagCode}
					onMobileResetButtonClick={resetFiltersParams}
				/>
			)}
			{!tariffsQueryProvider.loading && !tariffsQuery.loading && !tariffNewFormQuery.loading ? (
				newForm ? (
					<>
						<TariffsWithTagList
							{...props}
							text={text}
							windowSize={windowSizeModel.windowSizes}
							providers={providers}
							tariffs={tariffs}
							onProviderConnect={onProviderConnect}
							onProviderRates={onProviderRates}
							flat={ratesModel.orientation}
							pageName="tariffs_tags_region"
							providerModel={providerModel}
							isRatesTag={true}
							isRegionRatesTag={true}
						/>
						<AdverBlockContainer />
					</>
				) : (
					<ProvidersWithTariffsNoQuery
						{...props}
						hideProviderLogo={true}
						text={text}
						windowSize={windowSizeModel.windowSizes}
						providers={providersNoQuery}
						tariffs={tariffs}
						onProviderConnect={onProviderConnect}
						onProviderRates={onProviderRates}
						flat={ratesModel.orientation}
						pageName="tariffs_tags_region"
					/>
				)
			) : (
				<Stub />
			)}
			<PaginationContainer key={3} pagination={pagination} limit={limit} />
			<TopProviderContainer backgroundNone={true} />
		</>
	);
};

export default withRouter(inject("ApplicationModel")(observer(withStyles(styles)(Page))));
